import * as React from 'react';
import classnames from 'classnames';
import * as styles from './CloseButton.module.scss';

export type CloseButtonProps = React.HTMLAttributes<HTMLButtonElement>;

function CloseButton({ className, ...props }: CloseButtonProps) {
    return (
        <button
            type="button"
            {...props}
            className={classnames(styles.root, className)}
        />
    );
}

export default CloseButton;
